import React, { useRef, useState } from 'react'
import SbEditable from 'storyblok-react'
import ReactPlayer from 'react-player'
import cx from 'classnames'

import Image from './../Image'

import PlaySVG from './../../graphics/play.svg'
import PauseSVG from './../../graphics/pause.svg'

import styles from './styles.module.scss'

const Banner = (props, params) => {

    const [videoPlaying, setVideoPlaying] = useState(false)
    const [firstClick, setFirstClick] = useState(false)

    let dimensions
    let paddingTop

    if (props.blok.video.vimeo_oembed) {
        dimensions = {
            width: props.blok.video.vimeo_oembed.response.width,
            height: props.blok.video.vimeo_oembed.response.height
        }
    
        paddingTop = (dimensions.height / dimensions.width ) * 100
    }

    const videoButtonClasses = cx({
        'button': true,
        [styles['video-button']]: true,
        [styles['video-button--visible']]: !videoPlaying
    })

    const placeholderClasses = cx({
        [styles['banner__placeholder-wrapper']]: true,
        [styles['banner__placeholder-wrapper--visible']]: !firstClick
    })

    const toggleVideo = () => {
        if (!firstClick) setFirstClick(true)
        setVideoPlaying(!videoPlaying)
    }

	return (
		<SbEditable content={props.blok}>
			<section className={styles['banner']}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                {props.blok.video.vimeo_oembed && (
                    <div className={styles['banner__video-wrapper']} style={{ paddingTop: `${paddingTop}%` }}>
                        <ReactPlayer
                            className={styles['banner__video']}
                            url={props.blok.video.vimeo_raw}
                            width='100%'
                            height='100%'
                            playing={videoPlaying}
                        />
                        {props.blok.image.filename && (
                            <div className={placeholderClasses}>
                                <Image className={styles['banner__placeholder']} image={props.blok.image} blok={props.blok} params={{ maxWidth: 1000 }} />
                            </div>
                        )}
                        <div className={styles['video-button__wrapper']}>
                            <button className={videoButtonClasses} onClick={() => toggleVideo()}>
                                {videoPlaying ? <PauseSVG className={styles['video-button__pause']}/> : <PlaySVG className={styles['video-button__play']}/>}
                            </button>
                        </div>
                    </div>
                )}
                {props.blok.image.filename && !props.blok.video.vimeo_oembed && (
                    <figure className={styles['banner__image-wrapper']}>
                        <Image className={styles['banner__image']} image={props.blok.image} blok={props.blok} params={params || { maxWidth: 950 }} />
                    </figure>
                )}
                {!props.blok.image.filename && !props.blok.video.vimeo_oembed && (
                    <p style={{ textAlign: 'center', padding: '10rem 0'}}>Banner: Insert video link or select an image.</p>
                )}
            </section>
		</SbEditable>
	)
}

export default Banner